import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth.service';
import { AppStateService } from '../../app-state.service';
import { getApiHeaders } from '../../utils/api-headers.util';
import { transformPaymentGatewayResponse } from '../../utils/api-transformers.util';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private baseUrl: string = environment.apiUrl;
  orgTenantId: string | null

  constructor(
    private http: HttpClient,
    private appStateService: AppStateService,
    private authService: AuthService,
  ) {
      this.orgTenantId = this.appStateService.getState().orgTenantId;
     // Use tenant subdomain in all environments for proper multi-tenancy
     if (this.orgTenantId) {
      this.baseUrl = this.baseUrl.replace('https://', `https://${this.orgTenantId}.`);
     }
    }

  private getHeaders() {
    const authToken = this.authService.getAccessToken();
    return getApiHeaders(authToken);
  }

  postPayment(client_id: string, payment_data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${client_id}/payments/charge`, payment_data, {
      headers: this.getHeaders()
    });
  }

  getPaymentPublicKey(client_id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${client_id}/payments/public_key`, {
      headers: this.getHeaders()
    }).pipe(
      map(response => transformPaymentGatewayResponse(response))
    );
  }

  fetchAccountHistory(client_id: string, patient_id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${client_id}/patients/${patient_id}/statement`, {
      headers: this.getHeaders()
    });
  }

  fetchAccountAgingBalances(client_id: string, patient_id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${client_id}/patients/${patient_id}/aging-balance`, {
      headers: this.getHeaders()
    });
  }

  fetchPaymentsEnabledStatus(tenantId: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/payments_enabled/${tenantId}`, {
      headers: this.getHeaders()
    });
  }
  
}
